import Header from "../.shared/header/header";
import Footer from "../.shared/footer/footer";
import styles from './CookiePolicy.module.css';

export default function CookiePolicyPage() {
    return (
        <>
            <div className={styles.cookiePolicyContainer}>
                <Header />

                <div className={styles.headerSection}>
                    <h1 className={styles.title}>Cookie Policy</h1>
                    <span className={styles.subtitle}>
                        Learn about the cookies we use and how we use them to enhance your experience
                    </span>
                </div>

                <div className={styles.bodySection}>
                    <div className={styles.contentSection}>
                        <h2 className={styles.sectionTitle}>What Are Cookies?</h2>
                        <p className={styles.sectionContent} >
                            Cookies are small text files placed on your device when you visit a website. Cookies are widely used to enable website functionality, enhance security, analyze site usage, and improve user experience.
                            Cookies may be:
                        </p>
                        <ul className={styles.sectionList}>
                            <li><strong>Session cookies:</strong> which expire when you close your browser.</li>
                            <li><strong>Persistent cookies:</strong> which remain on your device for a defined period.</li>
                        </ul>
                    </div>

                    <div className={styles.contentSection}>
                        <h2 className={styles.sectionTitle}>Scope limitation</h2>
                        <p className={styles.sectionContent}>
                            Cookies and similar technologies used on tb2.health are not used to collect, store, or process protected health information (PHI).
                        </p>
                        <p className={styles.sectionContent}>
                            All medical, intake, consultation, and treatment-related data are collected only through secure, HIPAA-compliant systems governed by our Privacy Policy and applicable healthcare laws.
                        </p>
                        <p className={styles.sectionContent}>
                            Website analytics data is logically and technically separated from clinical systems and is never combined with medical records, intake data, or consultation information.
                        </p>
                    </div>

                    <div className={styles.contentSection}>
                        <h2 className={styles.sectionTitle}>Why we use cookies</h2>
                        <p className={styles.sectionContent} >
                            We use cookies to:
                        </p>
                        <ul className={styles.sectionList}>
                            <li>Maintain site stability and performance</li>
                            <li>Understand how visitors interact with non-clinical pages</li>
                            <li>Improve website usability and content.</li>
                            <li>Support marketing or advertising activities only where consent is provided.</li>
                        </ul>
                    </div>

                    <div className={styles.contentSection}>
                        <h2 className={styles.sectionTitle}>Types of cookies we use</h2>
                        <h3 className={styles.subsectionTitle}>Strictly Necessary Cookies</h3>
                        <p className={styles.sectionContent} >
                            These cookies are essential for the operation, security, and accessibility of the website and cannot be disabled. Examples include:
                        </p>
                        <ul className={styles.sectionList}>
                            <li>Enable page navigation and load balancing.</li>
                            <li>Protect against security threats and abuse.</li>
                            <li>Maintain basic site functionality.</li>
                        </ul>
                        <h3 className={styles.subsectionTitle}>Analytics & Performance Cookies</h3>
                        <p className={styles.sectionContent} >
                            These cookies help us understand how visitors use our website, such as which pages are visited and how users navigate non-clinical content.
                            We may use analytics tools such as:
                        </p>
                        <ul className={styles.sectionList}>
                            <li>PostHog</li>
                            <li>Microsoft Clarity</li>
                            <li>Google Analytics</li>
                        </ul>
                        <p className={styles.sectionContent} >These tools are configured to:</p>
                        <ul className={styles.sectionList}>
                            <li>Exclude the collection of protected health information.</li>
                            <li>Mask form inputs and sensitive fields.</li>
                            <li>Disable session replay on pages that may involve personal data.</li>
                            <li>Operate solely for website diagnostics and improvement.</li>
                        </ul>
                        <h3 className={styles.subsectionTitle}>Marketing & Advertising Cookies</h3>
                        <p className={styles.sectionContent} >
                            These cookies may be used to:
                        </p>
                        <ul className={styles.sectionList}>
                            <li>Deliver relevant advertisements.</li>
                            <li>Measure campaign effectiveness.</li>
                            <li>Limit the frequency of ads.</li>
                        </ul>
                        <p className={styles.sectionContent} >If enabled, these cookies may be set by third-party advertising or social media partners.</p>
                        <p className={styles.sectionContent} >TB2 Health does <strong>not sell or share protected health information</strong> for advertising purposes.</p>
                    </div>

                    <div className={styles.contentSection}>
                        <h2 className={styles.sectionTitle}>Health-related data and cookies</h2>
                        <p className={styles.sectionContent} >
                            TB2 Health does not use cookies or analytics tools to:
                        </p>
                        <ul className={styles.sectionList}>
                            <li>Collect health information.</li>
                            <li>Infer medical conditions.</li>
                            <li>Track treatment status.</li>
                            <li>Monitor patient behavior.</li>
                        </ul>
                        <p className={styles.sectionContent} >
                            Any health information you voluntarily provide through telemedicine intake forms, patient portals, or consultations is handled exclusively under our <strong>Privacy Policy</strong>
                            and in accordance with <strong>HIPAA and applicable healthcare regulations.</strong>
                        </p>
                    </div>

                    <div className={styles.contentSection}>
                        <h2 className={styles.sectionTitle}>Managing your cookie preferences</h2>
                        <p className={styles.sectionContent} >
                            You can manage or withdraw your cookie consent at any time by:
                        </p>
                        <ul className={styles.sectionList}>
                            <li>Using the cookie preference tool available on our website.</li>
                            <li>Adjusting your browser settings to block or delete cookies.</li>
                        </ul>
                        <p className={styles.sectionContent} >
                            Our cookie preference tool allows you to <strong>accept or reject non-essential cookies by category.</strong>
                            and in accordance with <strong>HIPAA and applicable healthcare regulations.</strong>
                        </p>
                        <p className={styles.sectionContent} >
                            Please note that disabling certain cookies may affect website functionality.
                        </p>
                    </div>

                    <div className={styles.contentSection}>
                        <h2 className={styles.sectionTitle}>Third-party cookies</h2>
                        <p className={styles.sectionContent} >
                            Some cookies may be placed by third-party services that appear on our website. We do not control these cookies.
                            Please review the privacy and cookie policies of the respective third parties for more information about their practices.

                        </p>
                    </div>

                    <div className={styles.contentSection}>
                        <h2 className={styles.sectionTitle}>Your privacy rights</h2>
                        <p className={styles.sectionContent} >
                            Depending on your location, you may have rights under applicable data protection laws, including the right to access, delete, or restrict certain data processing activities.
                        </p>
                        <p className={styles.sectionContent} >
                            Details regarding your rights and how to exercise them are provided in our Privacy Policy.
                        </p>
                    </div>
                    
                    <div className={styles.contentSection}>
                        <h2 className={styles.sectionTitle}>Changes to this Cookie Policy</h2>
                        <p className={styles.sectionContent} >
                            We may update this Cookie Policy to reflect changes in technology, law, or our practices. Updates will be posted on this page with a revised effective date.
                        </p>
                    </div>
                    
                    <div className={styles.contentSection}>
                        <h2 className={styles.sectionTitle}>Contact us</h2>
                        <p className={styles.sectionContent} >
                            If you have questions about this Cookie Policy or our use of cookies, contact us at:
                        </p>
                        <div className={styles.contactInfo}>
                            <p className={styles.sectionContent} >Email: <a href="mailto:privacy@tb2.health">privacy@tb2.health</a></p>
                        </div>
                    </div>
                </div>

            </div>
            <Footer/>
        </>
    );
}